import { WordPressPluginManager } from './admin/WordPressPluginManager';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

interface WordPressPluginAdminPageProps {
  onBack?: () => void;
}

export function WordPressPluginAdminPage({ onBack }: WordPressPluginAdminPageProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-4">
            {onBack && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onBack}
              >
                <ArrowLeft className="size-4 mr-2" />
                Back
              </Button>
            )}
            <div>
              <h1 className="text-2xl font-bold">WordPress Plugin Manager</h1>
              <p className="text-sm text-gray-600">
                Manage WordPress plugin downloads and publishing
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <WordPressPluginManager />
      </div>
    </div>
  );
}
